import styled from 'styled-components';

export const ButtonGrid = styled.div`
  margin-top: 16px;
`;
